import { ResultHl7Preview } from "features/results/components/ResultHl7Preview/ResultHl7Preview";
import { useResultHl7Document } from "features/results/hooks/useResultHl7Document";

import styles from "./CommonResultDetails.module.css";

const PreviewUnavailable = () => (
  <div className={styles.emptyState}>
    <p className={styles.emptyStateTitle}>Preview unavailable</p>
    <p className={styles.emptyStateText}>
      The HL7 stylesheet (XSL) for this message type hasn&apos;t been downloaded
      from Healthlink yet, so it can&apos;t be rendered.
    </p>
  </div>
);

// Order metadata (patient, status, referring doctor, dates) lives in the
// ResultsDetailPanel header above this; the common endpoint returns no parsed
// tests/results, so all that remains here is the styled HL7 document.
//
// That document is the list's own `rawXml` while the list still sends it, and is
// otherwise fetched for this row alone (KIN-2120).
export const CommonResultDetails = ({ item }) => {
  const document = useResultHl7Document(item);

  return (
    <div className={styles.hl7PreviewSection}>
      <ResultHl7Preview
        document={document}
        documentKind={item.resultType}
        fallback={<PreviewUnavailable />}
      />
    </div>
  );
};
